import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonos } from '../data/bonos';
import { packFacts, stackItems } from '../data/valueStack';
export function Bonos() {
  return <section className="w-full bg-white py-20 lg:py-28" aria-labelledby="bonos-heading" data-id="element-35" data-mp="2le6juoihfzq3">
      <div className="mx-auto max-w-content px-6" data-id="element-36" data-mp="2lcbw72ftttib">
        <div className="mx-auto max-w-2xl text-center" data-id="element-37" data-mp="2q5wwj14w6zko">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-flare-600" data-id="element-38" data-mp="2v3ygdoa572x7">
            El value stack
          </p>
          <h2 id="bonos-heading" className="mt-3 text-3xl font-black leading-tight tracking-tight text-ink-950 sm:text-4xl" data-id="element-39" data-mp="3029r0189hhgh">
            Más que solo tomos: herramientas de campo profesionales
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink-600" data-id="element-40" data-mp="392ptb7d9qijr">
            Estos 3 bonos son las herramientas que usamos en operaciones reales. No son teóricos. Los
            imprimes, los plastificas, los llevas a cada vuelo.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-41" data-mp="3e411edj0tevi">
          {bonos.map(bono => <article key={bono.id} className="flex h-full flex-col overflow-hidden rounded-xl border border-ink-950/10 bg-white" data-id="element-42" data-mp="3e63vp9r7hu61">
              <div className="flex flex-1 flex-col p-6 sm:p-7" data-id="element-43" data-mp="34dogulb7hlpd">
                <div className="flex items-center justify-between gap-3" data-id="element-44" data-mp="34c3o918gccu5">
                  <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-flare-600" data-id="element-45" data-mp="2zgo9m72mecwo">
                    {bono.label}
                  </span>
                  <span className="rounded-full bg-ink-100 px-3 py-1 text-[11px] font-semibold text-ink-600" data-id="element-46" data-mp="3s3925auu0v1t">
                    Valor {bono.value}
                  </span>
                </div>
                <h3 className="mt-3 text-lg font-bold leading-snug text-ink-950" data-id="element-47" data-mp="3i5uthxf5hak2">{bono.title}</h3>
                <p className="mt-2 text-sm font-semibold text-ink-700" data-id="element-48" data-mp="2bpaejtd34380">{bono.lead}</p>
                <ul className="mt-4 space-y-2" data-id="element-49" data-mp="26qfqod09foh1">
                  {bono.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2 text-sm leading-snug text-ink-600" data-id="element-50" data-mp="26sk2dh4ehrrv">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-flare-600" aria-hidden="true" data-id="element-51" data-mp="yp5xjnvvkald" />
                      <span data-id="element-52" data-mp="12q993y6w3kgs">{bullet}</span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="mt-14 grid gap-px overflow-hidden rounded-xl bg-ink-950/10 lg:grid-cols-[1.4fr_1fr]" data-id="element-53" data-mp="tqumxaxr9w23">
          <div className="bg-ink-950 p-8 text-white sm:p-10" data-id="element-54" data-mp="f27xggeeznx5">
            <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-flare-500" data-id="element-55" data-mp="jthmpfw1wp8i">
              Aquí está todo lo que te llevas hoy por USD 17
            </h3>
            <ul className="mt-6 divide-y divide-white/10 border-y border-white/10" data-id="element-56" data-mp="608gfo3egju7">
              {stackItems.map(item => <li key={item.name} className="flex items-center justify-between gap-4 py-3" data-id="element-57" data-mp="az1sdc31g2s9">
                  <span className="flex items-start gap-3 text-sm text-white/85" data-id="element-58" data-mp="3sbvtrnl8cu80">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-flare-500" aria-hidden="true" data-id="element-59" data-mp="12gmkoj72nnd" />
                    {item.name}
                  </span>
                  <span className="shrink-0 text-xs font-semibold uppercase tracking-wide text-white/45" data-id="element-60" data-mp="39m0umwydfo44">
                    {item.detail}
                  </span>
                </li>)}
            </ul>
          </div>
          <div className="bg-ink-900 p-8 text-white sm:p-10" data-id="element-61" data-mp="3il5rzzy75bep">
            <dl className="space-y-5" data-id="element-62" data-mp="g2j04540f90">
              {packFacts.map(fact => <div key={fact.label} data-id="element-63" data-mp="e7vqj6d8b1r">
                  <dt className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/45" data-id="element-64" data-mp="3skmvqbtw1f81">
                    {fact.label}
                  </dt>
                  <dd className="mt-1 text-base font-bold leading-snug" data-id="element-65" data-mp="a888963z8iki">{fact.value}</dd>
                </div>)}
            </dl>
          </div>
        </div>
      </div>
    </section>;
}